var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      class: ["sb-sidebar", _vm.isOpen ? "sb-sidebar-open" : ""],
      attrs: { "aria-label": "Main navigation" },
      on: {
        click: function($event) {
          $event.stopPropagation()
        },
        mouseenter: _vm.startHover,
        mouseleave: _vm.endHover
      }
    },
    [
      _c(
        "button",
        {
          class: ["sb-hamburger", _vm.isOpen ? "sb-sidebar-open" : ""],
          attrs: { title: _vm.isOpen ? "Close this panel" : "Toggle menu" },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.toggleDrawer($event)
            }
          }
        },
        [
          _c("span", { staticClass: "material-icons-outlined" }, [
            _vm._v(_vm._s(_vm.isOpen ? "close" : "menu"))
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "sb-sidebar-divider" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sb-nav-list" },
        [
          _vm._l(_vm.navBarGroups, function(group, idx) {
            return [
              _vm._l(group, function(item, jdx) {
                return _c(
                  "div",
                  { key: "ng-" + idx + "-" + jdx, staticClass: "sb-nav-group" },
                  [
                    item.subModules && item.subModules.length
                      ? _c(
                          "button",
                          {
                            class: [
                              "sb-nav-item",
                              _vm.highlightActiveLink(item) ? "active" : "",
                              _vm.expandedGroup === idx + "-" + jdx
                                ? "sb-nav-item-expanded"
                                : ""
                            ],
                            attrs: {
                              id: item.id || undefined,
                              title: item.title,
                              "aria-label": item.title,
                              "aria-current": _vm.highlightActiveLink(item)
                                ? "page"
                                : undefined
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.toggleGroup(idx + "-" + jdx)
                              }
                            }
                          },
                          [
                            item.customSvg
                              ? _c(
                                  "svg",
                                  {
                                    staticClass: "sb-nav-icon-svg",
                                    attrs: {
                                      width: "18",
                                      height: "18",
                                      viewBox: "0 0 18 18",
                                      fill: "none",
                                      xmlns: "http://www.w3.org/2000/svg",
                                      "aria-hidden": "true"
                                    }
                                  },
                                  [
                                    _c("circle", {
                                      attrs: {
                                        cx: "9",
                                        cy: "9",
                                        r: "3",
                                        fill: "none",
                                        stroke: "currentColor",
                                        "stroke-width": "1.5"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("circle", {
                                      attrs: {
                                        cx: "3",
                                        cy: "3",
                                        r: "1.5",
                                        fill: "currentColor"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("circle", {
                                      attrs: {
                                        cx: "15",
                                        cy: "3",
                                        r: "1.5",
                                        fill: "currentColor"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("circle", {
                                      attrs: {
                                        cx: "3",
                                        cy: "15",
                                        r: "1.5",
                                        fill: "currentColor"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("circle", {
                                      attrs: {
                                        cx: "15",
                                        cy: "15",
                                        r: "1.5",
                                        fill: "currentColor"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("line", {
                                      attrs: {
                                        x1: "4.06",
                                        y1: "4.06",
                                        x2: "7.17",
                                        y2: "7.17",
                                        stroke: "currentColor",
                                        "stroke-width": "1.3"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("line", {
                                      attrs: {
                                        x1: "13.94",
                                        y1: "4.06",
                                        x2: "10.83",
                                        y2: "7.17",
                                        stroke: "currentColor",
                                        "stroke-width": "1.3"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("line", {
                                      attrs: {
                                        x1: "4.06",
                                        y1: "13.94",
                                        x2: "7.17",
                                        y2: "10.83",
                                        stroke: "currentColor",
                                        "stroke-width": "1.3"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("line", {
                                      attrs: {
                                        x1: "13.94",
                                        y1: "13.94",
                                        x2: "10.83",
                                        y2: "10.83",
                                        stroke: "currentColor",
                                        "stroke-width": "1.3"
                                      }
                                    })
                                  ]
                                )
                              : _c(
                                  "span",
                                  { staticClass: "material-icons-outlined" },
                                  [_vm._v(_vm._s(item.iconText))]
                                ),
                            _vm._v(" "),
                            _c("span", { staticClass: "sb-nav-label" }, [
                              _vm._v(_vm._s(item.title))
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "material-icons-outlined sb-nav-chevron"
                              },
                              [_vm._v("expand_more")]
                            )
                          ]
                        )
                      : item.useRouter && item.link
                      ? _c(
                          "router-link",
                          {
                            class: [
                              "sb-nav-item",
                              _vm.highlightActiveLink(item) ? "active" : ""
                            ],
                            attrs: {
                              id: item.id || undefined,
                              to: item.link,
                              title: item.title,
                              "aria-label": item.title,
                              "aria-current": _vm.highlightActiveLink(item)
                                ? "page"
                                : undefined
                            },
                            nativeOn: {
                              click: function($event) {
                                return _vm.closeDrawer($event)
                              }
                            }
                          },
                          [
                            item.customSvg
                              ? _c(
                                  "svg",
                                  {
                                    staticClass: "sb-nav-icon-svg",
                                    attrs: {
                                      width: "18",
                                      height: "18",
                                      viewBox: "0 0 18 18",
                                      fill: "none",
                                      xmlns: "http://www.w3.org/2000/svg",
                                      "aria-hidden": "true"
                                    }
                                  },
                                  [
                                    _c("circle", {
                                      attrs: {
                                        cx: "9",
                                        cy: "9",
                                        r: "3",
                                        fill: "none",
                                        stroke: "currentColor",
                                        "stroke-width": "1.5"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("circle", {
                                      attrs: {
                                        cx: "3",
                                        cy: "3",
                                        r: "1.5",
                                        fill: "currentColor"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("circle", {
                                      attrs: {
                                        cx: "15",
                                        cy: "3",
                                        r: "1.5",
                                        fill: "currentColor"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("circle", {
                                      attrs: {
                                        cx: "3",
                                        cy: "15",
                                        r: "1.5",
                                        fill: "currentColor"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("circle", {
                                      attrs: {
                                        cx: "15",
                                        cy: "15",
                                        r: "1.5",
                                        fill: "currentColor"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("line", {
                                      attrs: {
                                        x1: "4.06",
                                        y1: "4.06",
                                        x2: "7.17",
                                        y2: "7.17",
                                        stroke: "currentColor",
                                        "stroke-width": "1.3"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("line", {
                                      attrs: {
                                        x1: "13.94",
                                        y1: "4.06",
                                        x2: "10.83",
                                        y2: "7.17",
                                        stroke: "currentColor",
                                        "stroke-width": "1.3"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("line", {
                                      attrs: {
                                        x1: "4.06",
                                        y1: "13.94",
                                        x2: "7.17",
                                        y2: "10.83",
                                        stroke: "currentColor",
                                        "stroke-width": "1.3"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("line", {
                                      attrs: {
                                        x1: "13.94",
                                        y1: "13.94",
                                        x2: "10.83",
                                        y2: "10.83",
                                        stroke: "currentColor",
                                        "stroke-width": "1.3"
                                      }
                                    })
                                  ]
                                )
                              : _c(
                                  "span",
                                  { staticClass: "material-icons-outlined" },
                                  [_vm._v(_vm._s(item.iconText))]
                                ),
                            _vm._v(" "),
                            _c("span", { staticClass: "sb-nav-label" }, [
                              _vm._v(_vm._s(item.title))
                            ])
                          ]
                        )
                      : item.link
                      ? _c(
                          "a",
                          {
                            class: [
                              "sb-nav-item",
                              _vm.highlightActiveLink(item) ? "active" : ""
                            ],
                            attrs: {
                              id: item.id || undefined,
                              href: item.link,
                              title: item.title,
                              "aria-label": item.title,
                              "aria-current": _vm.highlightActiveLink(item)
                                ? "page"
                                : undefined
                            },
                            on: { click: _vm.closeDrawer }
                          },
                          [
                            item.customSvg
                              ? _c(
                                  "svg",
                                  {
                                    staticClass: "sb-nav-icon-svg",
                                    attrs: {
                                      width: "18",
                                      height: "18",
                                      viewBox: "0 0 18 18",
                                      fill: "none",
                                      xmlns: "http://www.w3.org/2000/svg",
                                      "aria-hidden": "true"
                                    }
                                  },
                                  [
                                    _c("circle", {
                                      attrs: {
                                        cx: "9",
                                        cy: "9",
                                        r: "3",
                                        fill: "none",
                                        stroke: "currentColor",
                                        "stroke-width": "1.5"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("circle", {
                                      attrs: {
                                        cx: "3",
                                        cy: "3",
                                        r: "1.5",
                                        fill: "currentColor"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("circle", {
                                      attrs: {
                                        cx: "15",
                                        cy: "3",
                                        r: "1.5",
                                        fill: "currentColor"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("circle", {
                                      attrs: {
                                        cx: "3",
                                        cy: "15",
                                        r: "1.5",
                                        fill: "currentColor"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("circle", {
                                      attrs: {
                                        cx: "15",
                                        cy: "15",
                                        r: "1.5",
                                        fill: "currentColor"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("line", {
                                      attrs: {
                                        x1: "4.06",
                                        y1: "4.06",
                                        x2: "7.17",
                                        y2: "7.17",
                                        stroke: "currentColor",
                                        "stroke-width": "1.3"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("line", {
                                      attrs: {
                                        x1: "13.94",
                                        y1: "4.06",
                                        x2: "10.83",
                                        y2: "7.17",
                                        stroke: "currentColor",
                                        "stroke-width": "1.3"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("line", {
                                      attrs: {
                                        x1: "4.06",
                                        y1: "13.94",
                                        x2: "7.17",
                                        y2: "10.83",
                                        stroke: "currentColor",
                                        "stroke-width": "1.3"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("line", {
                                      attrs: {
                                        x1: "13.94",
                                        y1: "13.94",
                                        x2: "10.83",
                                        y2: "10.83",
                                        stroke: "currentColor",
                                        "stroke-width": "1.3"
                                      }
                                    })
                                  ]
                                )
                              : _c(
                                  "span",
                                  { staticClass: "material-icons-outlined" },
                                  [_vm._v(_vm._s(item.iconText))]
                                ),
                            _vm._v(" "),
                            _c("span", { staticClass: "sb-nav-label" }, [
                              _vm._v(_vm._s(item.title))
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(item.subModules || [], function(sub, sidx) {
                      return _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.expandedGroup === idx + "-" + jdx,
                              expression: "expandedGroup === idx + '-' + jdx"
                            }
                          ],
                          key: "sub-" + idx + "-" + jdx + "-" + sidx,
                          class: [
                            "sb-nav-sub-item",
                            _vm.currentLink.includes(
                              sub.href.split("#")[0].toLowerCase()
                            )
                              ? "active"
                              : ""
                          ],
                          attrs: { href: sub.href, title: sub.text },
                          on: { click: _vm.closeDrawer }
                        },
                        [_vm._v(_vm._s(sub.text))]
                      )
                    })
                  ],
                  2
                )
              }),
              _vm._v(" "),
              idx > 0 && idx < _vm.navBarGroups.length - 1
                ? _c("div", {
                    key: "nd-" + idx,
                    staticClass: "sb-sidebar-divider"
                  })
                : _vm._e()
            ]
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "nav-spacer" }),
      _vm._v(" "),
      _vm.isAdmin ? _c("div", { staticClass: "sb-sidebar-divider" }) : _vm._e(),
      _vm._v(" "),
      _vm.isAdmin
        ? _c(
            "a",
            {
              class: [
                "sb-nav-item",
                _vm.currentLink.includes("/admin") ? "active" : ""
              ],
              attrs: {
                "aria-current": _vm.currentLink.includes("/admin")
                  ? "page"
                  : undefined,
                title: "Administration",
                "aria-label": "Administration",
                href: _vm.SbBaseUrl + "/Admin"
              },
              on: { click: _vm.closeDrawer }
            },
            [
              _c("span", { staticClass: "material-icons-outlined" }, [
                _vm._v("settings")
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "sb-nav-label" }, [
                _vm._v("Administration")
              ])
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }